module.exports = __webpack_public_path__ + "img/accessory_hat_09.6e7ab969.svg";